// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";

const validateRequiredTextField = (value: string, fieldName?: string) => {
    if (!value || !value.trim()) {
        return siteMessage("Field_Required", fieldName || translate("This field")).toString();
    }
};

export default validateRequiredTextField;
